/* @flow */
import Format from './format'
import { formatNumber, parseFormatted } from '../../helpers/number'

/**
 * The FormattedNumberInput component class is meant to supply an input type tel field (for showing a keypad in mobile
 * devices) while displaying its value as a string of formatted numbers using delimiters.
 *
 * The pattern blocks alphabetic character input.
 * The component's base use is to provide a means to input currency / monetary amount value.
 */
class Number extends Format {
  static defaultProps = {
    ...Format.defaultProps,
    rootType: 'format-number',
    type: 'tel',
    decimal: false,
    options: {
      numeral: true,
      delimiter: "'",
      numeralPositiveOnly: true
    }
  }

  formatValue(value: string | number): string {
    if (typeof value == 'number') return formatNumber(value)
    if (typeof value == 'string') return value
    return ''
  }

  normalizeValue(value: string): ?(string | number) {
    const { decimal } = this.props
    const parsed = parseFormatted(value)

    const hasDecimal = decimal && value.indexOf('.') != -1
    const hasParsedDecimal = decimal && String(parsed).indexOf('.') != -1

    return hasDecimal != hasParsedDecimal || isNaN(parsed) ? value : parsed
  }
}

export default Number
